import { render, staticRenderFns } from "./BatchCheckTaxAfterComp.vue?vue&type=template&id=706ef3dc&scoped=true"
import script from "./BatchCheckTaxAfterComp.vue?vue&type=script&lang=js"
export * from "./BatchCheckTaxAfterComp.vue?vue&type=script&lang=js"
import style0 from "./BatchCheckTaxAfterComp.vue?vue&type=style&index=0&id=706ef3dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706ef3dc",
  null
  
)

export default component.exports